// Visibilidade de módulos inteiros da plataforma.
//
// O simulador foi retirado do ar a pedido do negócio (10/08/2026) até as condições
// dos produtos estarem padronizadas: os percentuais variam por parceiro e a base de
// cálculo da simulação ainda não é oficial (DECISOES_PENDENTES.md §2; a diretriz do
// PDF já dizia "só habilitar após a definição do parceiro"). Religar = trocar para true.
export const SIMULADOR_HABILITADO = false
